import i18n from 'i18n';

export enum ENVIRONMENTAL_CROPS_SEED_TYPES {
  SEED_PROCESSED = 'Seed - Processed',
  MIXTURE = 'Mixture',
}

export const ENVIRONMENTAL_CROPS_CONTACT_EMAIL = 'environmentalcrops@frontierag.co.uk';

export const ENVIRONMENTAL_CROPS_SEED_TYPE_LABELS: Record<ENVIRONMENTAL_CROPS_SEED_TYPES, string> =
  {
    [ENVIRONMENTAL_CROPS_SEED_TYPES.SEED_PROCESSED]: 'Standard',
    [ENVIRONMENTAL_CROPS_SEED_TYPES.MIXTURE]: 'Standard mixture',
  };

export const ENV_CROPS_PRICE_UOM_OPTIONS = {
  kg: ['kg', '4kg, K5kg, K15kg, K14kg, K12kg, 17kg, 22kg'],
  kgac: ['6kgac', '8kgac'],
  kac: ['10kac'],
  ac: ['Kac45'],
  k: ['ac50k', '17.5k', '25k', '24k', '20k'],
  kga: ['14kga', '15kga'],
  kgp: ['10kgp'],
  p: ['K300p'],
  u: ['K300u', 'K25u'],
  units: ['units'],
  noClearUnitSuffix: ['K7.5', 'K12.5', '18.75', 'K25'],
};

export const ENV_CROPS_PRICE_UOM_LABELS = Object.entries(ENV_CROPS_PRICE_UOM_OPTIONS).reduce(
  (acc, [key, value]) => {
    value.forEach((option) => {
      acc[option] = i18n.t(`envCropsPriceUOMLabels.${key}`, {
        defaultValue: key,
      });
    });
    return acc;
  },
  {} as Record<string, string>,
);

export const ENV_CROPS_MAX_DIGITS_AFTER_DECIMAL = 2;
export const ENV_CROPS_MAX_UNIT_PRICE = 99999999999; // 11 digits
